import { NOT_FOUND } from 'redux-first-router';
import { UNSUBSCRIBE, SUBSCRIBE, FORWARD, SWEEPS } from '../consts';

export default (state = {}, action = {}) => {
	switch (action.type) {
		case 'ARTICLE_FETCHING':
		case 'LANDER_FETCHING':
		case 'SLIDESHOW_FETCHING':
		case 'COMMITTEE_FETCHING':
			return {
				...state,
				isLoading: true,
        // shouldDestroyAds: false,
			}
		case 'ARTICLE_FETCHED':
		case 'LANDER_FETCHED':
		case 'SLIDESHOW_FETCHED':
		case 'COMMITTEE_FETCHED':
		    return {
		    	isLoading: false,
          // shouldDestroyAds: true,
		    	...action.payload.data
		    };
      		break;
	    default:
	      return state;
  }
};
